import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import type { MaskConfig } from '../utils/mask-utils';
import { formatValue } from '../utils/mask-utils';
export const useFormattedValues = (value, defaultValue, mask) => {
  const $ = _c(9);
  let t0;
  bb0: {
    if (!mask || !value) {
      t0 = value;
      break bb0;
    }
    let t1;
    if ($[0] !== mask || $[1] !== value) {
      t1 = formatValue(value, mask);
      $[0] = mask;
      $[1] = value;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    t0 = t1;
  }
  const formattedValue = t0;
  let t1;
  bb1: {
    if (!mask || !defaultValue) {
      t1 = defaultValue;
      break bb1;
    }
    let t2;
    if ($[3] !== defaultValue || $[4] !== mask) {
      t2 = formatValue(defaultValue, mask);
      $[3] = defaultValue;
      $[4] = mask;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    t1 = t2;
  }
  const formattedDefaultValue = t1;
  let t2;
  if ($[6] !== formattedDefaultValue || $[7] !== formattedValue) {
    t2 = {
      formattedValue,
      formattedDefaultValue
    };
    $[6] = formattedDefaultValue;
    $[7] = formattedValue;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
type FormattedPhoneValuesOptions = {
  value?: string;
  defaultValue?: string;
  mask?: MaskConfig;
  prefix?: string;
  getNationalNumber?: (prefix: string, fullNumber?: string) => string | null;
};
export const useFormattedPhoneValues = t0 => {
  const $ = _c(13);
  const {
    value,
    defaultValue,
    mask,
    prefix,
    getNationalNumber
  } = t0;
  let t1;
  if ($[0] !== getNationalNumber || $[1] !== mask || $[2] !== prefix || $[3] !== value) {
    bb0: {
      if (!mask || !value || !getNationalNumber || !prefix) {
        t1 = value;
        break bb0;
      }
      const nationalNumber = getNationalNumber(prefix, value);
      if (!nationalNumber) {
        t1 = value;
        break bb0;
      }
      t1 = formatValue(nationalNumber, mask);
    }
    $[0] = getNationalNumber;
    $[1] = mask;
    $[2] = prefix;
    $[3] = value;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const formattedValue = t1;
  let t2;
  if ($[5] !== defaultValue || $[6] !== getNationalNumber || $[7] !== mask || $[8] !== prefix) {
    bb1: {
      if (!mask || !defaultValue || !getNationalNumber || !prefix) {
        t2 = defaultValue;
        break bb1;
      }
      const nationalNumber_0 = getNationalNumber(prefix, defaultValue);
      if (!nationalNumber_0) {
        t2 = defaultValue;
        break bb1;
      }
      t2 = formatValue(nationalNumber_0, mask);
    }
    $[5] = defaultValue;
    $[6] = getNationalNumber;
    $[7] = mask;
    $[8] = prefix;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const formattedDefaultValue = t2;
  let t3;
  if ($[10] !== formattedDefaultValue || $[11] !== formattedValue) {
    t3 = {
      formattedValue,
      formattedDefaultValue
    };
    $[10] = formattedDefaultValue;
    $[11] = formattedValue;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};